import { createReducer, MetaReducer, on } from '@ngrx/store';
import { ITime } from '../../../../model/time';
import TimeDisplayActions from './time-display.action-types';

export const timeDisplayFeatureKey = 'timeDisplay';

export interface TimeDisplayState {
    time: ITime;
}

export const initialTimeDisplayState: TimeDisplayState = {
    time: {
        timeString: '',
        timeType: ''
    }
};

export const metaReducers: MetaReducer<TimeDisplayState>[] = [];

export const timeDisplayReducer = createReducer(
    initialTimeDisplayState,

    on(TimeDisplayActions.loadTimeDisplay, (state, action) => {
        return {
            time: action.time
        };
    })
);
